var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.82 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.06,2.65c-.15,0-.26.12-.26.26v2.91c0,.29.24.53.53.53h3.17c.29,0,.53-.24.53-.53v-2.91c0-.15-.12-.26-.26-.26H1.06ZM3.17,5.03h.79c.15,0,.27.12.27.26h0c0,.15-.12.27-.26.27h-.8c-.15,0-.27-.12-.27-.26,0,0,0,0,0,0,0-.15.12-.26.27-.26h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,2.65c-.07,0-.14,0-.2.05-.12.09-.14.25-.05.37,0,0,0,0,0,0l.79,1.06c.09.12.25.14.37.05,0,0,0,0,0,0,.12-.09.14-.25.05-.37l-.79-1.06c-.04-.06-.1-.09-.17-.1h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22,2.7c-.12-.09-.28-.06-.37.05,0,0,0,0,0,0L.05,3.81c-.09.12-.06.28.05.37.12.09.28.06.37-.05l.79-1.06c.09-.12.06-.28-.05-.37,0,0,0,0,0,0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91,0c-.15,0-.27.12-.27.26,0,0,0,0,0,0v.53c0,.15.12.27.26.27h0c.15,0,.26-.12.26-.27h0V.27C3.17.12,3.06,0,2.91,0h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36.39c-.13-.07-.29-.03-.36.1l-.27.46c-.07.13-.03.29.1.36,0,0,0,0,0,0,.13.07.29.03.36-.1,0,0,0,0,0,0l.26-.46c.07-.13.03-.29-.1-.36h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07,1.36l-.46.26c-.13.07-.17.24-.1.36.07.13.23.17.36.1,0,0,0,0,0,0l.46-.27c.13-.07.17-.24.1-.36-.07-.13-.24-.17-.36-.1h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65.36c-.07-.02-.14,0-.2.03-.13.07-.17.23-.1.36h0s.26.46.26.46c.07.13.23.17.36.1,0,0,0,0,0,0,.13-.07.17-.23.1-.36h0s-.26-.46-.26-.46c-.04-.06-.09-.11-.16-.12Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.55,1.33c-.07.02-.13.06-.16.12-.07.13-.03.29.1.36,0,0,0,0,0,0l.46.27c.13.07.29.03.36-.1,0,0,0,0,0,0,.07-.13.03-.29-.1-.36l-.46-.26c-.06-.04-.13-.05-.2-.03h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpty);
export default __webpack_public_path__ + "static/media/icon-empty.42e091b940b3a6af96465057f728be28.svg";
export { ForwardRef as ReactComponent };